import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  ButtonGroup,
  Tooltip,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import SyncIcon from "@material-ui/icons/Sync";
import SyncProblemIcon from "@material-ui/icons/SyncProblem";
import PropTypes from "prop-types";

import Rssi from "../Rssi";
import Battery from "../Battery";
import { useAppContext } from "../../../../context/AppContext";
import LinearProgressFill from "../LinearProgressFill";
import { useSensorsContext } from "../../../../context/SensorsContext";
import { DynamicTable } from "../../../common";

export default function TableSensors({ setView, setSensor }) {
  const { userType } = useAppContext();
  const { getSensorsTable, helpers } = useSensorsContext();
  const [sensors, setSensors] = React.useState([]);
  const columns = [
    { field: "empresa", label: "Sede / sucursal" },
    { field: "Cantidad", label: "Cantidad de Sensores"},
  ];

    const Subcolumns = [
    { field: "rssi",        label: "Nivel" },
    { field: "battery",     label: "Bateria" },
    { field: "filler",      label: "Llenado" },
    { field: "Material",    label: "Material" },
    { field: "updatedAt",   label: "Última lectura" },
    { field: "options",     label: "Opciones" },
  ];
  React.useEffect(() => {
    getSensorsTable().then((response) => {
      setSensors(response);
    });
  }, [getSensorsTable]);

  const viewSensorFunction = async (data) => {
    await setSensor(data);
    await setView("VIEW_SENSOR");
  };
  //Creacion de un diferencial entre la fecha actual y la fecha de el ultimo updatedAt
  const difference = (date) => {
    const now = new Date();
    const current = new Date(date);
    const diffTime = Math.abs(now - current);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
    if (diffDays > 1) {
      return { status: false, hours: diffHours - 1, days: diffDays - 1 };
    } else {
      return { status: true, hours: diffHours - 1, days: diffDays - 1 };
    }
  };
  const groupedSensors = sensors.reduce((acc, sensor) => {
      const key = userType === "LOCAL" ? sensor.imei : sensor.localID.name;
      if (!acc[key]) acc[key] = [];
      acc[key].push(sensor);
      return acc;
    }, {});
  const dynamicRows = Object.entries(groupedSensors).map(([key, group]) => ({
    empresa: key,
    Cantidad: group.length,
    configSubColumns: {
      columns: Subcolumns,
      rows: group.map((sensor, i) => {
        let diff = difference(sensor.lastReadDate);

        return {
          rssi: () =>
            sensor.rssi >= 0 && sensor.lastReadDate ? (
              <Rssi rssi={sensor.rssi} />
            ) : (
              <em>No se registra</em>
            ),
          battery: () =>
            sensor.battery >= 0 && sensor.lastReadDate ? (
              <Battery battery={sensor.battery} />
            ) : (
              <em>No se registra</em>
            ),
          filler: () => {
            if (sensor.localID.customerID === "63503b70633ef2107109cdbe") {
              return sensor.fill >= 70 && sensor.lastReadDate ? (
                <em>Lleno</em>
              ) : (
                <em>No lleno</em>
              );
            } else {
              return sensor.fill >= 0 && sensor.lastReadDate ? (
                <LinearProgressFill value={sensor.fill} />
              ) : (
                <em>No se registra</em>
              );
            }
          },
          Material: () =>
            (helpers[sensor.material.toLowerCase()] ||
              helpers[sensor.material.toUpperCase()])?.name ?? "Desconocido",
          updatedAt: () =>
            sensor.lastReadDate ? (
              <Tooltip title={`Hace ${diff.hours} horas, ${diff.days} días`}>
                <div>
                  {diff.status ? (
                    <SyncIcon style={{ color: "#00C851" }} />
                  ) : (
                    <SyncProblemIcon style={{ color: "#ffbb33" }} />
                  )}
                  {new Intl.DateTimeFormat("es-CL", {
                    year: "numeric",
                    month: "long",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  }).format(new Date(sensor.lastReadDate))}
                </div>
              </Tooltip>
            ) : (
              <em>No se registra</em>
            ),
          options: () => (
            <ButtonGroup size="small" variant="outlined">
              <Button color="primary" onClick={() => viewSensorFunction(sensor)}>
                <VisibilityIcon />
              </Button>
            </ButtonGroup>
          ),
        };
      }),
    },
  }));



  console.log("sensors", sensors);
  
  return (
    <DynamicTable columns={columns} rows={dynamicRows} />
  );
}

TableSensors.propTypes = {
  setView: PropTypes.func.isRequired,
  setSensor: PropTypes.func.isRequired,
};
